export default __webpack_public_path__ + "static/A_48-faf8b1ac73f417187080eee3d4bd4173.png";